
import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class ViewSurveyResult extends Vue {
  @Prop() guestbookVisit;

  dialog = false;

  closeDialog() {
    this.dialog = false;
    this.$store.dispatch("getGuestbookVisit", this.$route.params.id);
  }
}
